export const ESC_KEY_CODE = 27;

export const ISO_CODES = {
  US: 'us',
};



// WEBPACK FOOTER //
// ./src/constants/lang.js